import { Link } from 'react-router-dom';

export default function About() {
  return (
    <div className="space-y-20 pb-24">
      {/* Header Section */}
      <section className="relative overflow-hidden bg-brand-gray pt-28 pb-20 border-b border-slate-100">
        <div className="absolute inset-0 opacity-[0.04]" style={{ backgroundImage: 'radial-gradient(circle, #0f172a 1px, transparent 1px)', backgroundSize: '24px 24px' }} />
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 text-center relative z-10 space-y-4">
          <div className="text-xs font-bold uppercase tracking-widest text-brand-accent">Hvem er vi</div>
          <h1 className="text-4xl font-extrabold tracking-tight text-slate-900 sm:text-5xl">
            Om os
          </h1>
          <p className="mx-auto max-w-2xl text-lg text-slate-600">
            Læs mere om JC Svejseteknik, vores værdier og vores fokus på præcision og kvalitet.
          </p>
        </div>
      </section>

      {/* Main Content Section */}
      <section className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-2 lg:items-center">
          {/* Left: Verbatim Text */}
          <div className="space-y-6">
            <h2 className="text-3xl font-bold text-slate-900">Tekst på vej – kontakt os allerede nu</h2>
            <div className="text-slate-600 space-y-4 leading-relaxed">
              <p>
                Vi arbejder lige nu på at opdatere vores side med endnu mere information om vores ydelser inden for aluminiumssvejsning, TIG-svejsning, rør og procesanlæg.
              </p>
              <p>
                Men du behøver ikke vente – vi står klar til at hjælpe dig allerede i dag!
              </p>
              <p>
                Kontakt os for en uforpligtende snak om dit projekt, og hør hvordan vi kan skabe den rette løsning for dig.
              </p>
              <p>
                Ring eller skriv til os nu – og få professionel rådgivning og et tilbud skræddersyet til dit behov.
              </p>
            </div>
            <div className="pt-4">
              <Link
                to="/kontakt"
                className="rounded-md bg-brand-accent px-6 py-3 text-sm font-semibold tracking-wider text-white transition-all hover:bg-brand-accent/80"
              >
                Indhent et tilbud
              </Link>
            </div>
          </div>

          {/* Right: Image */}
          <div>
            <img
              src="https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=85,format=auto/assets/898ac264-e288-4855-90ba-a9f48bcc4333/smed-2-scaled.jpg"
              alt="JC Svejseteknik Smed"
              className="w-full rounded-2xl border border-slate-200 object-cover shadow-2xl aspect-[4/3]"
            />
          </div>
        </div>
      </section>

      {/* USPs Section */}
      <section className="bg-brand-gray py-16 border-y border-slate-100">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 gap-8 md:grid-cols-3">
            <div className="rounded-xl border border-slate-200 bg-white p-8 space-y-4 hover:shadow-md transition-shadow">
              <div className="flex h-12 w-12 items-center justify-center rounded-lg bg-brand-accent/10 text-brand-accent text-xl">
                <i className="fa-solid fa-bullseye" />
              </div>
              <h3 className="text-lg font-bold text-slate-900">Specialiseret præcisionsarbejde</h3>
              <p className="text-sm text-slate-500 leading-relaxed">
                vi leverer svejsninger med fokus på kvalitet og detaljer.
              </p>
            </div>

            <div className="rounded-xl border border-slate-200 bg-white p-8 space-y-4 hover:shadow-md transition-shadow">
              <div className="flex h-12 w-12 items-center justify-center rounded-lg bg-brand-accent/10 text-brand-accent text-xl">
                <i className="fa-solid fa-calendar-check" />
              </div>
              <h3 className="text-lg font-bold text-slate-900">Overholder deadlines</h3>
              <p className="text-sm text-slate-500 leading-relaxed">
                Vi ved, hvor vigtigt det er, at arbejdet bliver færdigt til tiden.
              </p>
            </div>

            <div className="rounded-xl border border-slate-200 bg-white p-8 space-y-4 hover:shadow-md transition-shadow">
              <div className="flex h-12 w-12 items-center justify-center rounded-lg bg-brand-accent/10 text-brand-accent text-xl">
                <i className="fa-solid fa-award" />
              </div>
              <h3 className="text-lg font-bold text-slate-900">Mange års brancheerfaring</h3>
              <p className="text-sm text-slate-500 leading-relaxed">
                Vores viden sikrer dig tryghed og professionelle løsninger.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Contact CTA Section */}
      <section className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="rounded-2xl border border-slate-200 bg-brand-gray p-8 md:p-12">
          <div className="grid grid-cols-1 gap-8 md:grid-cols-2 md:items-center">
            <div className="space-y-4">
              <h2 className="text-2xl font-bold text-slate-900">Kontakt os i dag</h2>
              <p className="text-slate-600 leading-relaxed">
                Har du brug for professionel svejsning i aluminium, TIG-svejsning, rør eller procesanlæg? Vi står klar til at hjælpe dig med præcise løsninger, høj kvalitet og hurtig levering.
              </p>
              <ul className="space-y-2 text-sm text-slate-500">
                <li className="flex items-center gap-2">
                  <i className="fa-solid fa-check text-brand-accent" />
                  Få svar på din henvendelse inden for 1-3 hverdage
                </li>
                <li className="flex items-center gap-2">
                  <i className="fa-solid fa-check text-brand-accent" />
                  Erfarne fagfolk med mangeårig erfaring
                </li>
                <li className="flex items-center gap-2">
                  <i className="fa-solid fa-check text-brand-accent" />
                  Vi servicerer både privatpersoner og erhverv
                </li>
              </ul>
            </div>
            <div className="flex flex-col gap-4 sm:flex-row sm:justify-end">
              <a
                href="tel:+4561167778"
                className="inline-flex items-center justify-center gap-3 rounded-md bg-brand-accent px-6 py-3.5 text-sm font-semibold tracking-wider text-white transition-all hover:bg-brand-accent/80"
              >
                <i className="fa-solid fa-phone" />
                <span className="whitespace-nowrap">+45 61 16 77 78</span>
              </a>
              <a
                href="mailto:info@jc-svejseteknik.dk"
                className="inline-flex items-center justify-center gap-3 rounded-md border border-slate-200 bg-white px-6 py-3.5 text-sm font-semibold tracking-wider text-slate-800 transition-all hover:bg-slate-50"
              >
                <i className="fa-solid fa-envelope" />
                <span className="whitespace-nowrap">info@jc-svejseteknik.dk</span>
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
